// extracted by mini-css-extract-plugin
export default {"main":"AlertComponent_main__Z+oh1","textNotif":"AlertComponent_textNotif__hGCJ0","close":"AlertComponent_close__8J0oN"};